var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "pdf-file",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#edeeef",
    d: "M53.42,10.15v43.7a2,2,0,0,1-2,2H20.14a2,2,0,0,1-2-2V23.09l11-14.94H51.42A2,2,0,0,1,53.42,10.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfd0d1",
    d: "M29.14,8.17V21a2,2,0,0,1-2,2H18.19Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.32,
    height: 14.04,
    x: 10.58,
    y: 35.47,
    fill: "#ff3717",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#edeeef",
    d: "M20.74 43.3v2.16H19V39.53H21.4a3.28 3.28 0 0 1 1.37.22 1.71 1.71 0 0 1 .75.66 1.9 1.9 0 0 1 .27 1 1.76 1.76 0 0 1-.56 1.37 2.13 2.13 0 0 1-1.51.52zm0-1.27h.58c.51 0 .76-.2.76-.59s-.23-.56-.7-.56h-.64zM24.44 45.46V39.53h2.19a2.56 2.56 0 0 1 2.13.88 3.16 3.16 0 0 1 .71 2.05 3 3 0 0 1-.76 2.16 2.55 2.55 0 0 1-2 .84zm1.74-1.37h.45a.85.85 0 0 0 .73-.44 2.16 2.16 0 0 0 .29-1.19 2.34 2.34 0 0 0-.26-1.12.83.83 0 0 0-.76-.46h-.45zM33.74 43.24H31.9v2.22H30.21V39.53H34.3v1.41H31.9v1h1.84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.6bd28e0ecfd65f5c79e8919715306fd1.svg";
export { ForwardRef as ReactComponent };